<template>
  <form id="client-webform" action="/client-webform" method="post" enctype="multipart/form-data" v-on:submit.prevent="submitForm">
    <h1>Client Enquiry Webform</h1>
    <p>Please provide your contact details below</p>

    <!-- Bind to the current routed path so that we can submit a traditional form post to the backend and know which form has been filled in -->
    <input name="path" type="hidden" v-model="$route.path">

    <label for="firstname">Client Agent First Name</label>
    <input name="firstname" type="text" id="firstname" v-model="firstname" required>

    <label for="lastname">Client Agent Last Name</label>
    <input name="lastname" type="text" id="lastname" v-model="lastname" required>

    <label for="email">Client Agent Email (enquiry updates will be sent to this address)</label>
    <input name="email" type="email" @blur="handleEmailBlur" id="email" v-model="email" required>
    <p id="email-validation-text" class="validation-error">{{email_validation_msg}}</p>

    <TrackingSearch/>
  </form>
</template>

<script>
import TrackingSearch from './components/TrackingSearch'
import BusinessAccountService from './api/BusinessAccountService'

export default {
  data () {
    return {
      email: '',
      email_validation_msg: ''
    }
  },
  mounted: function() {
    this.populateAgentDetails();
  },
  methods: {
    populateAgentDetails () {
      if (window.getCookie('populateAgentInfo') == '') {
        return;
      }
      // remove cookie
      window.setCookie('populateAgentInfo','',-1000);
      var agentDetails = window.getCookie('agentDetails');
      if (agentDetails == '') {
        return;
      }

      var agentDetailsArr = agentDetails.split('#');
      if (agentDetailsArr.length != 3) {
        return;
      }

      this.firstname = agentDetailsArr[0];
      this.lastname = agentDetailsArr[1];
      this.email = agentDetailsArr[2];
      // check for BA
      this.isBusinessAccountEmail();
      // remove cookie
      window.setCookie('agentDetails','',-1000);
    },
    submitForm (e) {
      if (!this.isEmailValid()) {
        window.scrollTo(0,0);
        return;
      }
      this.$store.state.isSubmitDisabled = true;
      this.setAgentCookie();
      document.getElementById("client-webform").submit();
    },
    setAgentCookie () {
      window.setCookie('agentDetails',this.firstname + '#' +  this.lastname + '#' + this.email);
    },
    isEmailValid() {
      const shorterEmailMsg = 'Please enter a shorter email address';
      const invalidEmailMsg = 'Please enter a valid email address';
      var val = this.email;
      val = val.trim();
      this.email = val;

      if (val === undefined || val == '') {
        this.email_validation_msg = '';
        return true;
      }

      if (val.length > 80) {
        this.email_validation_msg = shorterEmailMsg;
        return false;
      }

      const email_regex = /^((([-_!#$%&'*+\/=?^~`{|}\w]+(\.[.]?[-_!#$%&'*+\/=?^~`{|}\w]+)*)|(\"[^\"]+\"))@[0-9A-Za-z]+([\-]+[0-9A-Za-z]+)*(\.[0-9A-Za-z]+([\-]+[0-9A-Za-z]+)*)+[; ]*)$/;
      if(!val.match(email_regex)) {
        this.email_validation_msg = invalidEmailMsg;
        return false;
      }

      this.email_validation_msg = '';
      return true;
    },
    handleEmailBlur() {
      if (!this.isEmailValid()) {
        this.hideBAButtons();
        return;
      }

      this.isBusinessAccountEmail();
    },
    isBusinessAccountEmail() {
      BusinessAccountService
        .isBusinessAccount(this.email)
        .then((response) => {
          if (!response.data.baAccount) {
            this.manageBASpecificFlowButtons(false);
            this.hideBAButtons();
            return;
          }

          if (this.$store.state.trackingNumber === undefined || this.$store.state.trackingNumber === '') {
            this.$router.push('/').catch(err => {});
          }

          this.manageBASpecificFlowButtons(true);
          Array.from(document.getElementsByClassName('baButtons')).forEach(elem => elem.classList.remove('btnActive'));
          this.$store.state.businessAccount = true;
        })
        .catch(error => {
          this.hideBAButtons();
        });
    },
    manageBASpecificFlowButtons(newBaValue) {
      if((this.$store.state.businessAccount != newBaValue) && (this.$router.currentRoute.path.includes('/collection-enquiry'))) {
        this.$router.push('/collection-enquiry').catch(err => {});
      }
    },
    hideBAButtons() {
      this.$store.state.businessAccount = false;
    }
  },
  components: {
    TrackingSearch
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue